import csvParser from 'csvtojson';
import { findIndex } from 'lodash';

const SPECIAL_CHARS_REGEX = new RegExp('[^a-zA-Z0-9\\,\\- ]');

export const validateZipCodes: (zipCodes: string) => any | null = (zipCodes) => {
  if (zipCodes == null || zipCodes.trim().length <= 0) {
    return { fieldId: 'zipCodes', message: 'The Zip Codes field is required' };
  }

  if (SPECIAL_CHARS_REGEX.test(zipCodes)) {
    return {
      fieldId: 'zipcodes',
      message: 'Invalid Zip Codes format: Special characters are not allowed. Please provide correct data.',
    };
  }

  return null;
};

export const parseCsv = async (csvData: string) => {
  const text = csvData.trim();
  const lines = text.split('\n');
  const headers = lines[0].split(',').map((s) => s.trim()); // get all headers ignore case

  // #375306 Accept CSV File Uploads For FUEL Zip Code Imports
  // discover if there is headers in the first row with 'zipcode' as one of the columns
  let hasHeaders = false;
  const zipcodeIndex = findIndex(headers, (h: string) => {
    return h.toLowerCase() === 'zipcode';
  });
  const dmaIndex = findIndex(headers, (h: string) => {
    return h.toLowerCase() === 'dma';
  });
  if (dmaIndex > -1 && zipcodeIndex > -1) {
    hasHeaders = true;
  }
  const zipCodes = [];
  const csvOptions = {
    noheader: true,
    trim: true,
    ignoreEmpty: true,
  };
  const parsedCsv = await csvParser(csvOptions).fromString(text);

  for (let i = hasHeaders ? 1 : 0; i < parsedCsv.length; i++) {
    const e: Object = parsedCsv[i];
    if (hasHeaders) {
      // if we have header row then only add the zipcode column data
      zipCodes.push(e[Object.keys(e)[zipcodeIndex]]);
    } else {
      // otherwise pass through all the data in the entire excel sheet
      for (const [key, value] of Object.entries(e)) {
        // filter out all purely alphabetical values eg. 'Name'
        const isAlphabticalOnly = /^[a-zA-Z]+$/.test(value);
        if (!isAlphabticalOnly) {
          zipCodes.push(value);
        }
      }
    }
  }

  if (!zipCodes.length) {
    throw new Error('Invalid .csv file:Zip Codes cannot be empty.');
  }
  const retVal = zipCodes.join(',');
  return retVal;
};
